var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSearch(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.4412 9.58533L13.1181 12.2616L12.2338 13.146L9.5575 10.4691C8.56171 11.2673 7.32313 11.7015 6.04688 11.6997C2.94187 11.6997 0.421875 9.17971 0.421875 6.07471C0.421875 2.96971 2.94187 0.449707 6.04688 0.449707C9.15187 0.449707 11.6719 2.96971 11.6719 6.07471C11.6737 7.35096 11.2395 8.58954 10.4412 9.58533ZM9.1875 9.12158C9.9807 8.30589 10.4237 7.21248 10.4219 6.07471C10.4219 3.65721 8.46375 1.69971 6.04688 1.69971C3.62937 1.69971 1.67188 3.65721 1.67188 6.07471C1.67188 8.49158 3.62937 10.4497 6.04688 10.4497C7.18464 10.4515 8.27805 10.0085 9.09375 9.21533L9.1875 9.12158Z",
    fill: "#828282"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch);
export default __webpack_public_path__ + "static/media/search.c529fc683decbda6d0084f9a3f0d903f.svg";
export { ForwardRef as ReactComponent };